import { getCurrentUserRoles } from './manageSessionStorageData'
import { sameValueStringOrArray } from './comparators'

export const isAccessAllowedRules = (rulesAllowed: string[]): boolean =>
    sameValueStringOrArray(getCurrentUserRoles(), rulesAllowed)

export const isntAccessAllowedRules = (rulesAllowed: string[]): boolean =>
    !sameValueStringOrArray(getCurrentUserRoles(), rulesAllowed)
